import type { ApiClient } from '../../api/client';
import type {
  AbsenceSyncSettings,
  IntegrationSettingsPort,
  ProfileMappingConfiguration,
  ProviderProfileMappings,
} from '../../features/integrations/public';

export function createIntegrationSettingsHttpAdapter(client: ApiClient): IntegrationSettingsPort {
  return {
    getAbsenceSyncSettings() {
      return client.requestTenant<AbsenceSyncSettings>('/api/hr/v1/{tenant}/integrationSettings/absenceSync');
    },
    updateAbsenceSyncSettings(input) {
      return client.requestTenant<AbsenceSyncSettings>('/api/hr/v1/{tenant}/integrationSettings/absenceSync', {
        method: 'PUT', body: JSON.stringify(input),
      });
    },
    getProfileMappingConfiguration() {
      return client.requestTenant<ProfileMappingConfiguration>(
        '/api/hr/v1/{tenant}/integrationSettings/profileMappings',
      );
    },
    updateProfileMappings(provider, input) {
      return client.requestTenant<ProviderProfileMappings>(
        `/api/hr/v1/{tenant}/integrationSettings/profileMappings/${encodeURIComponent(provider)}`,
        {
          method: 'PUT',
          body: JSON.stringify(input),
        },
      );
    },
    updateProviderEnabled(provider, input) {
      return client.requestTenant<ProviderProfileMappings>(
        `/api/hr/v1/{tenant}/integrationSettings/providers/${encodeURIComponent(provider)}`,
        {
          method: 'PUT',
          body: JSON.stringify(input),
        },
      );
    },
  };
}
